import { ID, URL } from "@libs/interfaces/layouts"
import { getRoute, getSingleRoute } from "@libs/layouts"

const getProjectLink = (projectId: ID): URL => {
    const routeSingle = getSingleRoute("PEFestProject") 
    const url = routeSingle ? `/${getRoute(routeSingle)}/${projectId}` : "/" 
    return url
}

export default getProjectLink